import { render, staticRenderFns } from "./YandexImageSearch.vue?vue&type=template&id=61a9a83b&"
import script from "./YandexImageSearch.vue?vue&type=script&lang=js&"
export * from "./YandexImageSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports